import { useAuth } from '../hooks/useAuth'
import type { Permission } from '../types'

interface UsePermissionReturn {
  hasPermission: (permission: Permission) => boolean
  hasAnyPermission: (permissions: Permission[]) => boolean
  hasAllPermissions: (permissions: Permission[]) => boolean
  canView: (module: string) => boolean
  canEdit: (module: string) => boolean
  canDelete: (module: string) => boolean
}

export const usePermission = (): UsePermissionReturn => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuth()

  const canView = (module: string): boolean => {
    return hasPermission((module.includes('.') ? module : `${module}.view`) as Permission)
  }

  const canEdit = (module: string): boolean => {
    return hasPermission((module.includes('.') ? module : `${module}.edit`) as Permission)
  }

  const canDelete = (module: string): boolean => {
    return hasPermission((module.includes('.') ? module : `${module}.delete`) as Permission)
  }

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    canView,
    canEdit,
    canDelete,
  }
}
